import * as Features from '../../../../../../../shared/Features';
import * as PhotoStatus from '../../../../../../../shared/PhotoStatus';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { ImageEditorPhotoStatus } from '../../entry/queries/use-query-photo-status';

export function canDeleteEditedImages(
    user: AuthenticatedUser,
    photoStatus: ImageEditorPhotoStatus
): boolean {
    let isAcceptedOrder = photoStatus.currentStatus >= PhotoStatus.EditorApproved;

    if (isAcceptedOrder && !Features.hasFeature(Features.DeleteImagesAcceptedOrder, user)) {
        return false;
    }

    return (
        Features.hasFeature(Features.DeleteEditedImage, user) ||
        (photoStatus.photographerIsEditor &&
            Features.hasFeature(Features.HandleEditedImagesWhenPhotographerIsEditor, user))
    );
}

export function canDownloadUneditedImages(user: AuthenticatedUser): boolean {
    return Features.hasFeature(Features.DownloadImages, user);
}
